import type {
  InvoiceReaderTemplateFieldExtractionModel
} from "../models/ClientInvoiceReaderTemplateModel";
import type { TemplateFieldInput } from "../models/InvoiceInterpretationInputs";

export function stripTypename<T extends object>(obj: T): T {
  if (!obj) return obj;
  const { __typename, ...rest } = obj as any;
  return rest as T;
};

export const mapTemplateFieldsToInput = (
  fields: InvoiceReaderTemplateFieldExtractionModel[]
): TemplateFieldInput[] => {
  return fields.map((field) => ({
    fieldType: field.fieldType,

    label: field.label?.position
      ? {
          value: field.label.value,
          position: stripTypename(field.label.position),
        }
      : undefined,

    value: field.value?.position
      ? { position: stripTypename(field.value.position), value: field.value.value }
      : undefined,
  }));
};